import { render, staticRenderFns } from "./OrderViewActionSaveAndSend.vue?vue&type=template&id=53c5d647&scoped=true&"
import script from "./OrderViewActionSaveAndSend.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionSaveAndSend.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionSaveAndSend.vue?vue&type=style&index=0&id=53c5d647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5d647",
  null
  
)

export default component.exports